import React, { Component } from 'react';
import '../App.css';
import {Link, Redirect } from 'react-router-dom';
import MakeBlog from './MakeBlog';
/* global moment */
/* global $ */


// todo: loading states: not loaded, loading, loaded from local, loaded
// todo: responsive table

export default class Admin extends Component {
  constructor(props){
    super(props);
    this.state = {
      'users_loaded': false,
      'users': [],
      'sens_data_loaded': false,
      'sens_data': undefined,
      'posts_loaded': false,
      'posts': undefined,
      'comments_loaded': false,
      'comments': [],
      'blog_comments_loaded': false,
      'blog_comments': [],
      'pending_users_loaded': false,
      'pending_users': undefined,
      'pending_posts_loaded': false,
      'pending_posts': undefined,
      'blog_loaded': false,
      'blog': undefined,
      'page': 'users',
      'selected_items': [],
      'user_action': '',
      'user_action_id': '',
      'bulk_delete': false,
      'posts_content': {},
      'posts_content_loaded_uid': '',
      'posts_coms': {},
      'posts_coms_loaded_pid': '',
      'pid_range': ['', ''],
      'post_action': '',
      'post_action_id': '',
      'com_action': '',
      'com_action_id': '',
      'go_to': '',
      'scroll_to': '',
      'target': '',
      'reports': {},
      'reports_loaded': false,
      'emails': [],
      'emails_sep': '; ',
      'user_sort': 'registered',
      'user_sort_reverse': true,
    }
  }
  
  update_node(node) {
    let firebase = this.props.app_state.firebase;
    let db_ref = firebase.database().ref('/main');
    let order_by;
    switch (node) {
      case 'users': 
        db_ref.child('/users_sen').on('value', (snap2) => {
          let for_state1 = {};
          let data2 = snap2.val();
          for_state1['sens_data'] = data2;
          for_state1['sens_data_loaded'] = true;
          for_state1['emails'] = [];
          for (let uid in data2) {
            if ('email' in data2[uid])
              for_state1['emails'].push(data2[uid].email);
          }
          this.setState(for_state1);
        });
        order_by = 'registered';
      break;
      case 'comments':
        db_ref.child('posts').on('value', (snap) => {
          let for_state3 = {'comments': [], 'comments_loaded': true};
          let post_data = snap.val();
          let this_post;
          let this_comment;
          let comments;
          let nested_comments;
          let this_nested;
          for (let pid in post_data) {
            this_post = post_data[pid];
            comments = this_post.comments || {};
            for (let cid in comments) {
              this_comment = comments[cid];
              this_comment['post_id'] = pid;
              this_comment['post_title'] = this_post.title;
              this_comment['reply_to_type'] = 'post';
              this_comment['reply_to'] = pid;
              for_state3['comments'].push(this_comment);
              
              if (this_comment.comments) {
                nested_comments = this_comment.comments;
                for (let nid in nested_comments) {
                  this_nested = nested_comments[nid];
                  this_nested['post_id'] = pid;
                  this_nested['post_title'] = this_post.title;
                  this_comment['reply_to_type'] = 'comment';
                  this_comment['reply_to'] = cid;
                  for_state3['comments'].push(this_nested);
                }
              }
            }
          }
          for_state3['comments'].sort((b, a) => {
            return (a.pub_time||0) - (b.pub_time||0);
          });
          
          this.setState(for_state3);
        });
        db_ref.child('blog_posts').on('value', (snap) => {
          let for_state3 = {'blog_comments': [], 'blog_comments_loaded': true};
          let post_data = snap.val();
          let this_post;
          let this_comment;
          let comments;
          let nested_comments;
          let this_nested;
          for (let pid in post_data) {
            this_post = post_data[pid];
            comments = this_post.comments || {};
            for (let cid in comments) {
              this_comment = comments[cid];
              this_comment['post_id'] = pid;
              this_comment['post_title'] = this_post.title;
              this_comment['reply_to_type'] = 'blog';
              this_comment['reply_to'] = pid;
              for_state3['blog_comments'].push(this_comment);
              
              if (this_comment.comments) {
                nested_comments = this_comment.comments;
                for (let nid in nested_comments) {
                  this_nested = nested_comments[nid];
                  this_nested['post_id'] = pid;
                  this_nested['post_title'] = this_post.title;
                  this_comment['reply_to_type'] = 'blog_comment';
                  this_comment['reply_to'] = cid;
                  for_state3['blog_comments'].push(this_nested);
                }
              }
            }
          }              
          for_state3['blog_comments'].sort((b, a) => {
            return (a.pub_time||0) - (b.pub_time||0);
          });
          
          this.setState(for_state3);
        });
        return;
      case 'blog':
        order_by = 'pub_time';
        // might have blog posts already
      break;
      default:
        console.log('default reached in update node');
      break;
    }  
    
    db_ref.child(node).orderByChild(order_by).on('value', (snap) => {
      let for_state2 = {}
      let data;
      let data_list = [];
      snap.forEach((this_snap) => {
        data = this_snap.val();
        data_list.push(data);
      });
      
      for_state2[node] = data_list.reverse();
      for_state2[node+'_loaded'] = true;
      
      this.setState(for_state2);
    });      
  }
  waitForEl(selector, callback) {
    var fun = function (selector, callback) {
      if ($(selector).length) {
        callback();
      } else {
        setTimeout(function() {
          fun(selector, callback);
        }, 100);
      }
    }
    fun(selector, callback);
  }
  container_clicked(e, this_uid){
    if (this.props.app_state.this_user_loaded 
            && this_uid === this.props.app_state.this_user.id
            && (window.location.pathname.split('/')[2] || '') === 'users') {
      $('#alert_danger').text('You cannot edit your own data from this screen')
            .fadeIn().delay(2000).fadeOut();
      return;
    }
    
    let selected_items = this.state.selected_items;
    let selected = selected_items.includes(this_uid);
    
    let for_state = {};
    for_state['user_action'] = '';
    for_state['user_action_id'] = '';
    for_state['post_action'] = '';
    for_state['post_action_id'] = '';
    for_state['com_action'] = '';
    for_state['com_action_id'] = '';
    for_state['scroll_to'] = '';
    this.scroll_to = undefined;
    
    
    let page = window.location.pathname.split('/')[2] || '';
    let target = window.location.pathname.split('/')[3] || '';
    if (target !== '')
        window.history.pushState("", document.title, '/admin/'+page);
      
    if (this.state.target !== ''){
      this.setState({'target': ''});
    }
    if (selected){
      //$(e).removeClass('active');
      if (this.state.bulk_delete) {
        var index = selected_items.indexOf(this_uid);
        if (index > -1) {
          selected_items.splice(index, 1);
        }
      }
      else {
        selected_items = [];
      }
      for_state['selected_items'] = selected_items;
      this.setState(for_state);
    }
    else {
      //$(e).addClass('active');
      if(this.state.bulk_delete) {
        selected_items.push(this_uid);
      }
      else {
        selected_items = [this_uid];
      }
      for_state['selected_items'] = selected_items;
      this.setState(for_state);
    }
  }
  activate_bulk_delete(){
    let page = window.location.pathname.split('/')[2] || '';
    let target = window.location.pathname.split('/')[3] || '';
    if (target !== '')
        window.history.pushState("", document.title, '/admin/'+page);
    let for_state = {};
    for_state['user_action'] = '';
    for_state['user_action_id'] = '';
    for_state['post_action'] = '';
    for_state['post_action_id'] = '';
    for_state['com_action'] = '';
    for_state['com_action_id'] = '';
    for_state['scroll_to'] = '';
    this.scroll_to = undefined;
    
    if (this.state.bulk_delete) {      
      for_state['bulk_delete'] = false;
      for_state['selected_items'] = [];
      this.setState(for_state);
    }
    else {
      for_state['bulk_delete'] = true;
      this.setState(for_state);
    }
      
  }
  load_content(pid_list, uid){
    let firebase = this.props.app_state.firebase;
    let db = firebase.database().ref('/main/posts');
    let promise_list = [];
    let for_state = {'posts_content': {}, 'posts_content_loaded_uid': uid};
    pid_list.forEach((pid) => {
      promise_list.push(db.child(pid+'/content').once('value').then((snap) => {
        for_state['posts_content'][pid] = snap.val();
      }));
    });
    Promise.all(promise_list).then(() => {
      this.setState(for_state);
    });
  }
  load_comments(pid) {
    let firebase = this.props.app_state.firebase;
    let for_state = {'posts_coms': {}, 'posts_coms_loaded_pid': pid};
    
    firebase.database().ref('/main/posts/'+pid+'/comments').once('value').then((snap) => {
      for_state['posts_coms'] = snap.val()||{};
      let this_comment;
      for (let cid in for_state['posts_coms']) {
        for_state['posts_coms'][cid]['post_id'] = pid;
        for_state['posts_coms'][cid]['reply_to_type'] = 'post';
        for_state['posts_coms'][cid]['reply_to'] = pid;
        
        this_comment = for_state['posts_coms'][cid];        
        if (this_comment.comments) {
          for (let nid in this_comment.comments) {
            let this_nested = this_comment.comments[nid];
            for_state['posts_coms'][nid] = this_nested;
            for_state['posts_coms'][nid]['post_id'] = pid;
            for_state['posts_coms'][nid]['reply_to_type'] = 'comment';
            for_state['posts_coms'][nid]['reply_to'] = cid;
          }
        }
      }
      
      this.setState(for_state);
    });
  }
  
  pop_clicked(e, id, action, page, extra) {
    e.stopPropagation();
    
    if (page === 'posts') {
      this.setState({'post_action': action, 'post_action_id': id});
    }
    else if (page === 'comments') {
      if (action === 'view_parent')
        this.setState({'go_to': '/admin/posts/'+extra});
      else
        this.setState({'com_action': action, 'com_action_id': id});
    }
    else if (page === 'users')
      this.setState({'user_action': action, 'user_action_id': id});
  }
  
  // boss man
  confirm_action (action, targets, type, extra) {
    let firebase = this.props.app_state.firebase;
    if (action === '')
      return;
    
    let db = firebase.database().ref('/main');
    if (type === 'users') {
      if (action === 'admin') {
        let for_db = {};
        for_db['/users_sen/'+targets[0]+'/is_admin'] = true;
        
        let firebase_id = this.state.sens_data[targets[0]].firebase_id;
        for_db['/admin_firebase_ids/'+firebase_id+'/id'] = targets[0];
        for_db['/admin_firebase_ids/'+firebase_id+'/firebase_id'] = firebase_id;
        
        db.update(for_db)
        .then(() => {
          $('#alert_dark').text('Done').fadeIn().delay(1500).fadeOut();
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
      }
      else if (action === 'no_admin') {        
        let for_db = {};
        for_db['/users_sen/'+targets[0]+'/is_admin'] = false;
        
        let firebase_id = this.state.sens_data[targets[0]].firebase_id;
        for_db['/admin_firebase_ids/'+firebase_id] = null;
        
        db.update(for_db)
        .then(() => {
          $('#alert_dark').text('Done').fadeIn().delay(1500).fadeOut();
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
      }
      else if (action === 'delete') {
        let for_db = {};
        let this_user;
        targets.forEach((uid) => {
          this_user = this.state.sens_data[uid];
          if (typeof this_user === 'undefined') 
            return;
          
          for_db['/users/'+uid] = null;
          for_db['/users_sen/'+uid] = null;
          for_db['/blacklist/'+uid] = {'id': uid, 'email': this_user.email};
          
        });
        db.update(for_db)
        .then(() => {
          $('#alert_dark').text('Done').fadeIn().delay(1500).fadeOut();
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
      }
    }
    else if (type === 'posts') {
      if (action === 'delete') {
        let for_db = {};
        let this_post;
        targets.forEach((pid) => {
          this_post = this.props.app_state.posts_info_dict[pid];
          for_db['posts/'+pid] = null;
          for_db['users/'+this_post.author+'/posts/'+pid] = null;
        });
        
        db.update(for_db)
        .then(() => {
          $('#alert_dark').text('Done').fadeIn().delay(1500).fadeOut();
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
      }
    }
    else if (type === 'comments') {
      if (action === 'delete') {
        let for_db = {};
        let this_comment;
        targets.forEach((cid) => {
          for (let i = 0; i < this.state.comments.length; i++)
            if (this.state.comments[i]['id'] === cid) {
              this_comment = this.state.comments[i];
              break;
            }
          for (let j = 0; j < this.state.blog_comments.length; j++)
            if (this.state.blog_comments[j]['id'] === cid) {
              this_comment = this.state.blog_comments[j];
              break;
            }
          if (typeof this_comment === 'undefined') {
            this_comment = this.state.posts_coms[cid];
          }
          if (typeof this_comment === 'undefined') {
            return;
          }
          if (this_comment.reply_to_type === 'post') {
            for_db['/posts/'+this_comment.post_id+'/comments/'+cid] = null;
            for_db['/users/'+this_comment.author+'/comments/'+cid] = null;
          }
          else if (this_comment.reply_to_type === 'comment') {
            for_db['/posts/'+this_comment.post_id+'/comments/'+this_comment.reply_to+'/comments/'+cid] = null;
            for_db['/users/'+this_comment.author+'/comments/'+cid] = null;
          }
          else if (this_comment.reply_to_type === 'blog') {
            for_db['/blog_posts/'+this_comment.post_id+'/comments/'+cid] = null;
            for_db['/users/'+this_comment.author+'/comments/'+cid] = null;
          }
          else if (this_comment.reply_to_type === 'blog_comment') {
            for_db['/blog_posts/'+this_comment.post_id+'/comments/'+this_comment.reply_to+'/comments/'+cid] = null;
            for_db['/users/'+this_comment.author+'/comments/'+cid] = null;
          }
        });
        
        db.update(for_db)
          .then(() => {
            $('#alert_dark').text('Done').fadeIn().delay(1500).fadeOut();
          })
          .catch((error) => {
            $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
          });
      }
    }
    
    let for_state = {};
    for_state['user_action'] = '';
    for_state['user_action_id'] = '';
    for_state['post_action'] = '';
    for_state['post_action_id'] = '';
    for_state['com_action'] = '';
    for_state['com_action_id'] = '';
    for_state['selected_items'] = [];
    for_state['scroll_to'] = '';
    for_state['bulk_delete'] = false;
    this.scroll_to = undefined;
    this.setState(for_state);
    $('#really').modal('hide');
  }
  
  confirm_bulk(type) {
    if (this.state.selected_items.length === 0) {
      $('#alert_warning').text('Nothing selected').fadeIn().delay(1500).fadeOut();
      return;
    }
    if (type === 'users')
      this.setState({'user_action': 'bulk_delete'});
    else if (type === 'posts')
      this.setState({'post_action': 'bulk_delete'});
    else if (type === 'comments')
      this.setState({'com_action': 'bulk_delete'});
  }
  
  view_delete(e, id, action, type) {
    e.stopPropagation();
    
    let for_state = {};
    if (action === 'view') {
      if (type === 'post') {
        for_state['go_to'] = '/admin/posts/'+id;
      }
      else if (type === 'comment') {
        for_state['go_to'] = '/admin/comments/'+id;
      }
    }
    else if (action === 'delete') {
      if (type === 'post') {
        for_state['user_action'] = 'delete_post';
        for_state['post_action_id'] = id;
      }
      if (type === 'comment') {
        for_state['post_action'] = 'delete_comment';
        for_state['com_action_id'] = id;
      }
    }
    
    this.setState(for_state);
  }
  
  // react life cycle
  componentDidMount() {    
    this.update_node.bind(this)('users');
    // comments probably won't auto update
    //this.update_node('comments');
    
    
    this.waitForEl('#admin_link', function() {
      $('#admin_link').addClass('bold');
    }); 
    
    $('#really').on('hidden.bs.modal', () => {
      let for_state = {};
      for_state['user_action'] = '';
      for_state['user_action_id'] = '';
      for_state['post_action'] = '';
      for_state['post_action_id'] = '';
      for_state['com_action'] = '';
      for_state['com_action_id'] = '';
      for_state['selected_items'] = [];
      for_state['scroll_to'] = '';
      for_state['bulk_delete'] = false;
      this.scroll_to = undefined;
      this.setState(for_state);
    });
    
    $('#emails').on('hidden.bs.modal', () => {
      $('#copy_btn').text('Copy');
    });
    
    let firebase = this.props.app_state.firebase;
    firebase.database().ref('/main/reports').on('value', (snap) => {
      let reports = snap.val()||{};
      
      this.setState({
        'reports': reports,
        'reports_loaded': true,
      });
    });
  }
  componentDidUpdate(prev_props, prev_state) {
    let page = window.location.pathname.split('/')[2] || 'users';
    page = page.toLowerCase();
    
    let loaded = this.state[page+'_loaded'];
    
    // changing page
    if (this.state.page !== prev_state.page) {
      // load only once (on page change) if not loaded       
      if (!loaded && (page==='users' || page==='comments'))
        this.update_node(this.state.page);
      
      let for_state = {};
      for_state['user_action'] = '';
      for_state['user_action_id'] = '';
      for_state['post_action'] = '';
      for_state['post_action_id'] = '';
      for_state['com_action'] = '';
      for_state['com_action_id'] = '';
      for_state['selected_items'] = [];
      for_state['scroll_to'] = '';
      for_state['bulk_delete'] = false;
      this.scroll_to = undefined;
      this.setState(for_state);
    }
    
    if (typeof this.scroll_to !== 'undefined' 
        && this.scroll_to !== null
        && (page === 'users' 
        || (page === 'posts'
           && this.state.posts_content_loaded_uid === '[all]'
           && this.props.app_state.posts_info_loaded)
        || (page === 'comments'
           && this.state.comments_loaded
           && this.state.blog_comments_loaded))) {
             
      this.scroll_to.scrollIntoView({behavior: 'smooth'});
      let id = this.scroll_to.getAttribute('id');
      //this.scroll_to = undefined;
      let selected_items = this.state.selected_items;
      if (!selected_items.includes(id)) {
        selected_items.push(id);
        
        this.setState({'selected_items': selected_items});
      }
      //this.setState({'scroll_to': '', 
      //  'selected_items': selected_items});
    }
    
    if (this.state.target !== prev_state.target) {
      if (this.state.scroll_to !== this.state.target) {
        this.setState({'scroll_to': this.state.target});
      }
    }
  }
  componentWillUnmount() {    
    $('#admin_link').removeClass('bold');
  }
  pid_range = ['', ''];
   
   // main render function
  render() {
    if (this.props.app_state.this_user_loaded &&
            (this.props.app_state.this_user === null
            || this.props.app_state.this_user.is_admin !== true))
      return <Redirect to='/' />;
    
    
    let page = window.location.pathname.split('/')[2] || 'users';
    page = page.toLowerCase();
    if (page !== this.state.page) {
      this.setState({'page': page});
    }
    
    if (this.state.go_to !== '' && this.state.go_to.split('/')[2] !== page) {
      this.setState({'go_to': ''});
      return <Redirect to={this.state.go_to} />;
    }
    
    let target = window.location.pathname.split('/')[3] || '';
    if (target !== '' && this.state.target !== target) {
      this.setState({'target': target});
    }
    
    let loaded = this.state[page+'_loaded'];
    
    
    // for users
    let for_render;
    if (page === 'users') {
      let users_xml = [];
      let sens_data = this.state.sens_data || {};
      let this_sens_data;
      let this_selected;
      let user_content;
      let this_user = this.props.app_state.this_user;
      let current_user = false;
      let this_post_content;
      let user_pids = [];
      
      let delete_btn = null;
      if(this.state.bulk_delete){
        delete_btn = <button id="bulk_confirm_btn"
                              onClick={this.confirm_bulk.bind(this, 'users')}
                              className="btn btn-danger">
          Delete Selected Users ({this.state.selected_items.length})
        </button>;
      }
      
      // first line
      users_xml.push(<div className="container_first bold">
        <t className="item"
            onClick={()=>{
              if (this.state.user_sort === 'id')
                return this.setState({'user_sort_reverse': !this.state.user_sort_reverse});
              
              this.setState({'user_sort': 'id', 'user_sort_reverse': false});
            }}>ID</t>
        <t className="item"
            onClick={()=>{
              if (this.state.user_sort === 'name')
                return this.setState({'user_sort_reverse': !this.state.user_sort_reverse});
              
              this.setState({'user_sort': 'name', 'user_sort_reverse': false});
            }}>Username</t>
        <t className="item"
            onClick={()=>{
              if (this.state.user_sort === 'registered')
                return this.setState({'user_sort_reverse': !this.state.user_sort_reverse});
              
              this.setState({'user_sort': 'registered', 'user_sort_reverse': true});
            }}>Registered</t>
        <t className="item small_item"
            onClick={()=>{
              if (this.state.user_sort === 'num_posts')
                return this.setState({'user_sort_reverse': !this.state.user_sort_reverse});
              
              this.setState({'user_sort': 'num_posts', 'user_sort_reverse': true});
            }}>Posts</t>
        <t className="item email"
            onClick={()=>{
              if (this.state.user_sort === 'email')
                return this.setState({'user_sort_reverse': !this.state.user_sort_reverse});
              
              this.setState({'user_sort': 'email', 'user_sort_reverse': false});
            }}>Email</t>
        <t className="item small_item"
            onClick={()=>{
              if (this.state.user_sort === 'email_verified')
                return this.setState({'user_sort_reverse': !this.state.user_sort_reverse});
              
              this.setState({'user_sort': 'email_verified', 'user_sort_reverse': false});
            }}>Email Verified</t>
        <t className="item small_item"
            onClick={()=>{
              if (this.state.user_sort === 'wants_courage')
                return this.setState({'user_sort_reverse': !this.state.user_sort_reverse});
              
              this.setState({'user_sort': 'wants_courage', 'user_sort_reverse': false});
            }}>Weekly Email</t>
        <t className="item small_item"
            onClick={()=>{
              if (this.state.user_sort === 'is_admin')
                return this.setState({'user_sort_reverse': !this.state.user_sort_reverse});
              
              this.setState({'user_sort': 'is_admin', 'user_sort_reverse': false});
            }}>Admin</t>
        {delete_btn}
      </div>);
      
      
      
      let all_users = [];
      this.state.users.forEach((user) => {
        all_users.push(user);
      });        
      // sort
      all_users.sort((b, a) => {
        if (['email_verified', 'wants_courage', 'is_admin', 
                'email'].includes(this.state.user_sort)) {        
          a = sens_data[a.id] || {};
          b = sens_data[b.id] || {};
        }
        if (['email_verified', 'wants_courage', 'is_admin'].includes(this.state.user_sort)) {
          // a false b true? a is smaller
          if (typeof a[this.state.user_sort] !== 'undefined' 
                && typeof b[this.state.user_sort] !== 'undefined') {
            if (!a[this.state.user_sort] && b[this.state.user_sort])
              return (this.state.user_sort_reverse)?1:-1;
            // a true b false? b is smaller
            if (a[this.state.user_sort] && !b[this.state.user_sort])
              return (this.state.user_sort_reverse)?-1:1;
            // a === b  
            if (a[this.state.user_sort] === b[this.state.user_sort])
              return 0;
          }
          
          // a undefined? a is smaller
          if (typeof a[this.state.user_sort] === 'undefined' 
                && typeof b[this.state.user_sort] !== 'undefined')
            return (this.state.user_sort_reverse)?1:-1;            
          // b undefined? b is smaller
          if (typeof a[this.state.user_sort] !== 'undefined' 
                && typeof b[this.state.user_sort] === 'undefined')
            return (this.state.user_sort_reverse)?-1:1;
          
          // both n/a? equal
          return 0;
        }
        
        let default_val = '';
        // what should i sort by, and what if that value is n/a or a num or str?
        if (['registered', 'num_posts'].includes(this.state.user_sort)) {
          default_val = 0;        
          // fix this
          if (this.state.user_sort === 'num_posts') {   
            let num_posts = 0;
            if (typeof a.posts !== 'undefined')
              num_posts = Object.keys(a.posts).length;            
            a.num_posts = num_posts;
                               
            num_posts = 0;
            if (typeof b.posts !== 'undefined')
              num_posts = Object.keys(b.posts).length;            
            b.num_posts = num_posts;            
          }
        }
        
        if ((a[this.state.user_sort]||default_val) > (b[this.state.user_sort]||default_val))
          return (this.state.user_sort_reverse)?1:-1;
        if ((a[this.state.user_sort]||default_val) === (b[this.state.user_sort]||default_val))
          return 0;
        if ((a[this.state.user_sort]||default_val) < (b[this.state.user_sort]||default_val))
          return (this.state.user_sort_reverse)?-1:1;                
      });
      
      all_users.forEach((user) => {
        current_user = this_user !== null && this_user.id === user.id;
        
        let num_posts = 0;
        if (typeof user.posts !== 'undefined')
          num_posts = Object.keys(user.posts).length;
        
        this_selected = this.state.selected_items.includes(user.id);
        this_sens_data = sens_data[user.id] || {};
        let wants_courage_str = 'n/a';
        if(typeof this_sens_data['wants_courage'] !== 'undefined')
          wants_courage_str = (this_sens_data['wants_courage'])?'✔':'x';
        
        user_content = [<t className="item">{user.id}</t>,
          <t className="item">{user.name}</t>,
          <t className="item">{(user.registered)?moment(user.registered).format('M/DD/YY'):'n/a'}</t>,
          <t className="item small_item">{num_posts}</t>,
          <t className="item email">{this_sens_data['email']||'n/a'}</t>,
          <t className="item small_item">{(this_sens_data['email_verified'])?'✔':'x'}</t>,
          <t className="item small_item">{wants_courage_str}</t>,
          <t className="item small_item">{(this_sens_data['is_admin'])?'✔':'x'}</t>];
          
        if(this_selected && this.state.selected_items.length === 1 
                          && this.state.user_action === ''
                          && !this.state.bulk_delete
                          && !current_user){
                            
          let admin_action = (this_sens_data.is_admin)?'no_admin':'admin';
          user_content.push(<div className="popover bs-popover-right" role="tooltip" x-placement="right">
            <div className="arrow" style={{"top":"24"}}></div>
            <div className="popover-header">Actions:</div>
            <div id="pop_posts" 
                  onClick={((e) => this.pop_clicked(e, user.id, 'posts', 'users'))}
                  className="popover-body">View Posts ({num_posts})</div>
            <div id="pop_admin" 
                  onClick={((e) => this.pop_clicked(e, user.id, admin_action, 'users'))}
                  className="popover-body" uid={user.id}>
              {this_sens_data.is_admin?'Remove Admin Status':'Make Admin'}
            </div>
            <div id="pop_delete" 
                  onClick={((e) => this.pop_clicked(e, user.id, 'delete', 'users'))}
                  className="popover-body" uid={user.id}>Delete</div>
          </div>);
        }
        let this_showing_posts = this.state.user_action_id === user.id  
                                      && (this.state.user_action === 'posts'
                                          || this.state.user_action === 'delete_post');
        let showing_posts = [];
        
        if (this_showing_posts && this_selected) {
          let posts_dict = user.posts;
          if (typeof posts_dict !== 'undefined' && Object.keys(posts_dict).length > 0) {
            user_pids = [];
            for(let pid in posts_dict) {
              user_pids.push(pid);
              if(this.state.posts_content_loaded_uid === user.id)
                this_post_content = this.state.posts_content[pid];
              else
                this_post_content = '...';
              showing_posts.push(<hr/>);
              showing_posts.push(<div className="user_post">
                <t>{(posts_dict[pid].title||'').substr(0, 25)}</t>
                <t>({pid})</t>
                <t className="content_preview">{' '+(this_post_content||'').substr(0, 100)+'...'}</t>
                <button className="btn btn-dark" 
                        onClick={((e) =>this.view_delete(e, pid, 'view', 'post'))}>View</button>
                <button className="btn btn-danger"
                        onClick={(e) =>this.view_delete(e, pid, 'delete', 'post')}>
                  Delete
                </button>
              </div>);
            }
            if(this.state.posts_content_loaded_uid !== user.id) {
              this.load_content(user_pids, user.id);
            }
          }
          else {            
            showing_posts.push(<hr/>);
            showing_posts.push(<div>
              This user has not created any posts
            </div>);
          }
        }
        users_xml.push(<div className={"my_container "+(this_selected?'active ':' ')
                                                        +(this_showing_posts?'showing_posts ':'')
                                                        +(current_user?'current_user ':'')} 
                            id={user.id}
                            ref={(node) => {if(this.state.scroll_to === user.id)this.scroll_to = node}}
                            onClick={((el) => this.container_clicked(el, user.id))}>
          {user_content}
          {showing_posts}
        </div>);
        
      });
      if (users_xml.length === 1) {
        if(loaded)
          users_xml.push(<h4>No users found</h4>);
        else 
          users_xml.push(<h4 className="text-muted">Loading...</h4>);
      }
      
      for_render = <div id="admin_user_container">
        {users_xml}
      </div>;
    }
    
    
    // for posts
    if (page === 'posts') {
      let posts_xml = [];
      
      let delete_btn = null;
      if(this.state.bulk_delete){
        delete_btn = <button id="bulk_confirm_btn"
                              onClick={this.confirm_bulk.bind(this, 'posts')}
                              className="btn btn-danger">
          Delete Selected Posts ({this.state.selected_items.length})
        </button>;
      }
      
      posts_xml.push(<div className="container_first bold">
        <t className="item">ID</t>
        <t className="item">Title</t>
        <t className="item">Published</t>
        <t className="item post_content">Content</t>
        <t className="item">Comments</t>
        <t className="item">Author</t>
        {delete_btn}
      </div>);
      
      let this_selected = false;
      let post_content;
      let num_all_posts = this.props.app_state.posts_info.length;
      let pid_range = ['', ''];
      let pid_list = [];
      this.props.app_state.posts_info.forEach((post, index) => {
        pid_list.push(post.id);
        if (index === 0)
          pid_range[0] = post.id;
        if (index === num_all_posts - 1)
          pid_range[1] = post.id;
        
        let content = '...';
        if (this.state.posts_content_loaded_uid === '[all]')
          content = this.state.posts_content[post.id] || '';
        
        this_selected = this.state.selected_items.includes(post.id);
        post_content = [<t className="item">{post.id}</t>,
          <t className="item">{post.title}</t>,
          <t className="item">{(post.pub_time)?moment(post.pub_time).format('M/DD/YY'):'n/a'}</t>,
          <t className="item post_content">{content.substring(0, 100)+"..."}</t>,
          <t className="item">{post.num_comments}</t>,
          <t className="item">{post.author}</t>,];
          
          
        let this_full_post = this.state.post_action_id === post.id  
                                    && (this.state.post_action === 'view_post');
        let full_post_xml = '';
        if (this_full_post && this_selected) {
          let this_post_content;
          if(this.state.posts_content_loaded_uid === '[all]')
            this_post_content = this.state.posts_content[post.id]||'...';
          else
            this_post_content = '...';
              
          full_post_xml = [<hr/>,
                            <t className="full_post">{this_post_content}</t>];
        }  
        
        
        let showing_coms = this.state.post_action_id === post.id  
                                    && (this.state.post_action === 'comments'
                                        || this.state.post_action === 'delete_comment');
         
        let coms_xml = [];
        if (showing_coms && this_selected) {
          let coms_dict = {}
          if (this.state.posts_coms_loaded_pid === post.id)
            coms_dict = this.state.posts_coms;
          
          let this_comment;
          if (Object.keys(coms_dict).length > 0) {
            for(let cid in coms_dict) {
              this_comment = coms_dict[cid];
              
              coms_xml.push(<hr/>);
              coms_xml.push(<div className="post_comment">
                <t>{this_comment.author}</t>
                <t>({this_comment.id})</t>
                <t className="content_preview">{' '+(this_comment.content||'').substr(0, 100)+'...'}</t>
                <button className="btn btn-dark"
                        onClick={((e) =>this.view_delete(e, cid, 'view', 'comment'))}>
                  View
                </button>
                <button className="btn btn-danger"
                        onClick={((e) =>this.view_delete(e, cid, 'delete', 'comment'))}>
                  Delete
                </button>
              </div>);
            }
          }
          else {            
            coms_xml.push(<hr/>);
            coms_xml.push(<div className="content_preview">
              This post does not have any comments
            </div>);
          }
          if (this.state.posts_coms_loaded_pid !== post.id)
            this.load_comments(post.id);
        }
                
         
        if(this_selected && this.state.selected_items.length === 1 
                          && this.state.post_action === ''
                          && !this.state.bulk_delete
                          && !this_full_post
                          && !showing_coms){
          post_content.push(<div className="popover bs-popover-right" role="tooltip" x-placement="right">
            <div className="arrow" style={{"top":"24"}}></div>
            <div className="popover-header">Actions:</div>
            <div id="pop_viewpost" 
                  className="popover-body" 
                  onClick={((e) => this.pop_clicked(e, post.id, 'view_post', 'posts'))}>View Post</div>
            <div id="pop_coms" className="popover-body"
                  onClick={((e) => this.pop_clicked(e, post.id, 'comments', 'posts'))}>Comments ({post.num_comments})</div>
            <div id="pop_delete" className="popover-body"
                  onClick={((e) => this.pop_clicked(e, post.id, 'delete', 'posts'))}>Delete</div>
          </div>);
        }
        
        
        
        posts_xml.push(<div className={"my_container "+(this_selected?'active ':' ')
                                                        +(false?'showing_posts ':'')} 
                            id={post.id}
                            ref={(node) => {if(this.state.scroll_to === post.id)this.scroll_to = node}}
                            onClick={((el) => this.container_clicked(el, post.id))}>
          {post_content}
          {full_post_xml}
          {coms_xml}
        </div>);
        
      });
              
      if (this.state.posts_content_loaded_uid !== '[all]' 
            && this.props.app_state.posts_info_loaded)
        this.load_content(pid_list, '[all]');
      
      
      if (this.state.pid_range[0] !== pid_range[0] || this.state.pid_range[1] !== pid_range[1]) {
        this.setState({'pid_range': pid_range});
      }
      
      if (posts_xml.length === 1) {
        if(this.state.posts_content_loaded_uid === '[all]')
          posts_xml.push(<h4>No posts found</h4>);
        else 
          posts_xml.push(<h4 className="text-muted">Loading...</h4>);
      }
      for_render = <div id="posts_container">
        {posts_xml}
      </div>;
    }
    
    
    
    // for comments
    if (page === 'comments') {
      let coms_xml = [];
      
      let delete_btn = null;
      if(this.state.bulk_delete){
        delete_btn = <button id="bulk_confirm_btn"
                              onClick={this.confirm_bulk.bind(this, 'comments')}
                              className="btn btn-danger">
          Delete Selected Comments ({this.state.selected_items.length})
        </button>;
      }
      
      coms_xml.push(<div className="container_first bold">
        <t className="item">ID</t>
        <t className="item">Published</t>
        <t className="item com_content">Content</t>
        <t className="item">Parent Post</t>
        <t className="item">Author</t>
        {delete_btn}
      </div>);
      
      let this_selected = false;
      let com_content;
      let all_comments = [];
      this.state.comments.forEach((comment) => {
        all_comments.push(comment);
      });        
      this.state.blog_comments.forEach((comment) => {
        all_comments.push(comment);
      });
      all_comments.sort((b, a) => {
        return (a.pub_time||0) - (b.pub_time||0);
      });
      all_comments.forEach((comment) => {
        this_selected = this.state.selected_items.includes(comment.id);
        com_content = [<t className="item">{comment.id}</t>,
          <t className="item">{(comment.pub_time)?moment(comment.pub_time).format('M/DD/YY'):'n/a'}</t>,
          <t className="item com_content">{(comment.content||'').substring(0, 90)+"..."}</t>,
          <t className="item">{comment.post_title}</t>,
          <t className="item">{comment.author}</t>,];
          
         
        let this_full_com = this.state.com_action_id === comment.id  
                                    && this.state.com_action === 'view_com';
        let full_post_xml = '';
        if (this_full_com && this_selected) {
              
          full_post_xml = [<hr/>,
                            <t className="full_com">{comment.content}</t>];
                            
          com_content.push(full_post_xml);
        }
        
        
        if(this_selected && this.state.selected_items.length === 1 
                          && this.state.com_action === ''
                          && !this.state.bulk_delete
                          && !this_full_com){
          let view_post_btn = null;
          if (comment.reply_to_type !== 'blog' && comment.reply_to_type !== 'blog_comment')
            view_post_btn = <div id="pop_parent" className="popover-body"
                  onClick={((e) => this.pop_clicked(e, comment.id, 'view_parent', 
                                                        'comments', comment.post_id))}>
              View Post
            </div>;
            
          com_content.push(<div className="popover bs-popover-right" role="tooltip" x-placement="right">
            <div className="arrow" style={{"top":"24"}}></div>
            <div className="popover-header">Actions:</div>
            <div id="pop_viewcom" 
                  className="popover-body" 
                  onClick={((e) => this.pop_clicked(e, comment.id, 'view_com', 'comments'))}>View Comment</div>
            {view_post_btn}
            <div id="pop_delete" className="popover-body"
                  onClick={((e) => this.pop_clicked(e, comment.id, 'delete', 'comments'))}>Delete</div>
          </div>);
        } 
        
        
        coms_xml.push(<div className={"my_container "+(this_selected?'active ':' ')
                                                        +(false?'showing_com ':'')} 
                            id={comment.id}
                            ref={(node) => {if(this.state.scroll_to === comment.id)this.scroll_to = node}}
                            onClick={((e) => this.container_clicked(e, comment.id))}>
          {com_content}
        </div>);
      });
      
      
      if (coms_xml.length === 1) {
        if(this.state.comments_loaded && this.state.blog_comments_loaded)
          coms_xml.push(<h4>No comments found</h4>);
        else 
          coms_xml.push(<h4 className="text-muted">Loading...</h4>);
      }
      for_render = <div id="coms_container">
        {coms_xml}
      </div>;
    }
    
    
    if (page === 'blog') {
      for_render = <MakeBlog app_state={this.props.app_state} />;
    }
    
    // for reports
    if (page === 'reports') {
      if (!this.state.reports_loaded)
        for_render = <h3 className="text-muted">Loading...</h3>
      else if(Object.keys(this.state.reports).length === 0){
        for_render = <h3>No Reports</h3>;
      }
      else {
        for_render = 'reports';
        let rep_xml_list = [];
        let this_report;
        
        let path = '';
        for(let rid in this.state.reports) {
          this_report = this.state.reports[rid];
          path = '/admin/';
          if (this_report.type === 'nested_comment' 
                || this_report.type === 'blog_comment' 
                || this_report.type === 'nested_blog_comment' )
            path += 'comments/';
          else
            path += this_report.type + 's/';
          
          path += this_report.reported_id;
          
          rep_xml_list.push(<Link to={path}>
            <div className="rep_cont">
              <t className="rep_item">{this_report.type}</t>
              <t className="rep_item">{this_report.reported_id}</t>
              <t className="rep_item comment">{this_report.comment}</t>
              <t className="rep_item">{this_report.reporter_name}</t>
            </div>
          </Link>);
        }
        
        rep_xml_list.push(<div className="rep_cont first_row">
          <t className="rep_item">Type</t>
          <t className="rep_item">ID</t>
          <t className="rep_item comment">Comment</t>
          <t className="rep_item">Reporter</t>
        </div>);
        
        rep_xml_list.reverse();
        
        for_render = <div id="all_reports">
          {rep_xml_list}
        </div>;
      }
    }
    
    
    let emails_btn = '';
    if(page === 'users')
      emails_btn = <button id="emails_show_btn" className="btn btn-outline-light"
                              onClick={e => $('#emails').modal('show')}>
        Emails
      </button>;
    
    let bulk_delete_btn = <button id="bulk_delete_btn" className="btn btn-danger"
                                            onClick={this.activate_bulk_delete.bind(this)}>
      {(this.state.bulk_delete)?'Cancel':'Bulk Delete'}
    </button>;
    if (page === 'blog') {
      bulk_delete_btn = '';
    }    
    
    
    // are you sure? modal
    let targets = [];
    let action = '';
    let modal_body;
    let type = '';
    let extra = '';
    switch(page) {
      case 'users':
        action = this.state.user_action;
        targets = [this.state.user_action_id];
        type = 'users';
        if (action === 'admin') {
          modal_body = <div className="modal_body">
            You are about to make the following user an Admin:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
        else if (action === 'no_admin') {
          modal_body = <div className="modal_body">
            You are about to remove the following user's Admin status:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
        else if (action === 'delete') {
          modal_body = <div className="modal_body">
            You are about to Delete the following user:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
        else if (action === 'bulk_delete') {
          action = 'delete';
          targets = this.state.selected_items;
          modal_body = <div className="modal_body">
            You are about to Delete the following users:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
        else if (action === 'delete_post') {
          action = 'delete';
          type = 'posts';
          targets = [this.state.post_action_id];
          modal_body = <div className="modal_body">
            You are about to Delete the following post:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
      break;
      case 'posts':
        type = 'posts';
        targets = [this.state.post_action_id];
        action = this.state.post_action;
        if (action === 'delete') {
          modal_body = <div className="modal_body">
            You are about to Delete the following post:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
        else if (action === 'bulk_delete') {
          action = 'delete';
          targets = this.state.selected_items;
          modal_body = <div className="modal_body">
            You are about to Delete the following posts:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
        else if (action === 'delete_comment') {
          action = 'delete';
          type = 'comments';
          targets = [this.state.com_action_id];
          modal_body = <div className="modal_body">
            You are about to Delete the following comment:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
      break;
      case 'comments':
        type = 'comments';
        action = this.state.com_action;
        targets = [this.state.com_action_id];
        if (action === 'delete') {
          modal_body = <div className="modal_body">
            You are about to Delete the following comment:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
        else if (action === 'bulk_delete') {
          action = 'delete';
          targets = this.state.selected_items;
          modal_body = <div className="modal_body">
            You are about to Delete the following comments:<br/>
            <t style={{"fontWeight":"bold"}}>{targets.join(', ')}</t><br/>
            Please confirm<br/>
          </div>;
          
          $('#really').modal('show');
        }
      break;
      default: 
        console.log('default for admin page');
      break;
    }
    
    return (
      <div id="admin_div">
        <div className="btn_container">
          <Link to={"/admin/users"}>
            <div className={"bar_btn" + ((page==='users')?" active":"")}>
              <i className="material-icons">people</i>
              <span className="bar_btn_text">Users</span>
            </div>
          </Link>
          <Link to={"/admin/posts"}>
            <div className={"bar_btn" + ((page==='posts')?" active":"")}>
              <i className="material-icons">create</i>
              <span className="bar_btn_text">Posts</span>
            </div>
          </Link>
          <Link to={"/admin/comments"}>
            <div className={"bar_btn" + ((page==='comments')?" active":"")}>
              <i className="material-icons chat">chat</i>
              <span className="bar_btn_text">Comments</span>
            </div>
          </Link>
          <Link to={"/admin/blog"}>
            <div className={"bar_btn" + ((page==='blog')?" active":"")}>
              <i className="material-icons">grade</i>
              <span className="bar_btn_text">Blog Posts</span>
            </div>
          </Link>
          <Link to={"/admin/reports"}>
            <div className={"bar_btn" + ((page==='reports')?" active":"")}>
              <i className="material-icons">warning</i>
              <span className="bar_btn_text">Reports</span>
            </div>
          </Link>
          {bulk_delete_btn}
          {emails_btn}
        </div>
        

        
        {for_render}
        
        
        <div id="really" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Are you sure?</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            
            {modal_body}
            
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.confirm_action.bind(this, action, targets, type, extra)} type="button" className="btn btn-dark">Confirm</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>
        
        <div id="emails" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document"
              style={{"max-width": "90%"}}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">All Emails</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div id="email_list" className="modal_body"
                  style={{"padding": "10px", "wordWrap": "break-word"}}>
              {this.state.emails.join(this.state.emails_sep)}
            </div>
            <div style={{'margin-top': '20px'}} className="modal-footer">
              Seporator:
              <input onChange={e => {
                this.setState({'emails_sep': e.target.value});
              }} className="form-control"
                  style={{"max-width": "60px", "marginLeft": "10px"}}
                  value={this.state.emails_sep}></input>
              <button onClick={ e => {
                if (document.selection) { 
                  let range = document.body.createTextRange();
                  range.moveToElementText(document.getElementById('email_list'));
                  range.select().createTextRange();
                } else if (window.getSelection) {
                  let range = document.createRange();
                  range.selectNode(document.getElementById('email_list'));
                  window.getSelection().addRange(range);
                }
                  
                try {  
                  // Now that we've selected the anchor text, execute the copy command  
                  let successful = document.execCommand('copy');  
                  if (successful)
                    $(e.target).text('Copied');
                                  
                } catch(err) {
                }  
                window.getSelection().removeAllRanges();  
                  
              }} type="button" className="btn btn-dark" id="copy_btn">Copy</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

/*
const cat_names = {
  'relationships': 'Relationships',
  'mentalhealth': 'Mental Health',
  'sexualorientation': 'Sexual Orientation',
  'loss': 'Loss',
  'race': 'Race',
  'suicide': 'Suicide',
  'abuse': 'Abuse',
  'addiction': 'Addiction',
  'eatingdisorders': 'Eating Disorders',
  'miscellaneous': 'Miscellaneous',
  'religion': 'Religion',
}
*/
// image location by character count


// WEBPACK FOOTER //
// ./src/components/Admin.js